<template>
  <div
    class="counselor-top-section__image"
    :class="{ 'has-video': isTherapyRole && hasVideo }"
    @click="isTherapyRole && hasVideo ? openVideoModal() : null"
  >
    <div class="counselor-image__thumbnail" v-html="thumbnailHtml"></div>
    <button
      v-if="isTherapyRole && hasVideo"
      class="btn secondary counselor-top-section__image-button counselor-video-modal__vue"
      aria-label="Play introduction video"
      aria-haspopup="dialog"
      aria-expanded="false"
      @click.stop="openVideoModal"
    >
      Video
    </button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { useUser } from 'Main/composables/useUser';

export default {
  name: 'CounselorImage',

  setup() {
    const { maybeFetchUser, getUpdatedSchedule } = useUser();
    return { maybeFetchUser, getUpdatedSchedule };
  },

  data() {
    const dataset = this.$mountEl.dataset;

    return {
      advisorId: dataset.advisorId || dataset.counselorId || '',
      role: dataset.role || dataset.currentRole || '',
      counselorDataFromDOM: dataset.counselorData
        ? JSON.parse(dataset.counselorData)
        : null,
    };
  },

  computed: {
    ...mapState('user', ['isLoading', 'name', 'video']),

    thumbnailHtml() {
      // Fallback to DOM data
      if (
        this.counselorDataFromDOM &&
        this.counselorDataFromDOM.thumbnailCircle
      ) {
        return this.counselorDataFromDOM.thumbnailCircle;
      }

      return '';
    },

    isTherapyRole() {
      const currentRole = this.role;
      const isTherapy = currentRole === 'therapist';
      return isTherapy;
    },

    hasVideo() {
      return !!(
        this.video &&
        (this.video.browser720_h264_encoded ||
          this.video.video_webm ||
          this.video.original)
      );
    },

    videoThumbnail() {
      return this.video?.video_thumbed || '';
    },

    h264VideoUrl() {
      return this.video?.browser720_h264_encoded || '';
    },

    webmVideoUrl() {
      return this.video?.video_webm || '';
    },
  },

  created() {
    this.maybeFetchUser(this.advisorId);
  },

  methods: {
    ...mapActions('counselorVideo', ['toggleModal']),

    openVideoModal() {
      this.toggleModal();
    },
  },
};
</script>

<style scoped>
/* Styles moved to _top-section.scss */
</style>
